exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sar-upload{text-decoration: underline; font-weight: 700; text-transform: capitalize;}\n.linksar{width:100%; float: left; margin-top:25px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/sar-upload/sar-upload.component.css
// module id = ../../../../../src/app/pages/sar-upload/sar-upload.component.css
// module chunks = main